import React, { Component } from 'react'
import styles from './index.module.less'
const ReactMarkdown = require('react-markdown/with-html')
import { Card } from 'antd'


class Doc extends Component {
  render() {
    const { dataSource, className, docType } = this.props;
    let dataSourceItem = dataSource[0];
    let renderItem;
    if (docType === 'FAQ') {
      renderItem = (
        <div>
          <p style={{"fontWeight":"bold"}}>提问:</p>
          <br />
          <p>{dataSourceItem.question}</p>
          <br />
          <p style={{"fontWeight":"bold"}}>回答:</p>
          <div className={styles.container}>
          <ReactMarkdown source={dataSourceItem.answer} escapeHtml={false}></ReactMarkdown>
          </div>
        </div>
      );
    } else {
      renderItem = (
        <div className={styles.container}>
          <ReactMarkdown source={dataSourceItem.content} escapeHtml={false} ></ReactMarkdown>
        </div>
      );
    }
    const title = (<div style={{"textAlign": "center"}}>{dataSourceItem.title}</div>);
    return (
      <Card title={title} bordered={false}>
        {renderItem}  
      </Card>
    )
  }
}
export default Doc;

